import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { StatusCodes } from 'http-status-codes';
import { catchError, EMPTY, Observable, timeout } from 'rxjs';

import { CURRENT_SETTINGS } from 'src/configs/settings/current-settings';

import { AppErrorMajor } from '../core/app-error/app-error-major.enum';
import { AppError } from '../core/app-error/app-error.interface';
import { appErrorMajor } from '../core/app-error/store/app-error.actions';
import { DEFAULT_HTTP_TIMEOUT, UrlPart } from '../utils/global-constants';

const toAppError = (e: unknown): AppError => ({
  statusCode: StatusCodes.INTERNAL_SERVER_ERROR,
  message: (e as Error).message,
  name: (e as Error).name,
  type: AppErrorMajor.LoadMotorization
});

/**
 * Intercepts the requests and delegates to error page after a specified timeout without a result
 */
@Injectable()
export class HttpTimeoutInterceptor implements HttpInterceptor {
  public constructor(private readonly store: Store) {}

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes(UrlPart.Motorizations)) {
      return next.handle(request).pipe(
        timeout(CURRENT_SETTINGS.apis.backend.timeout?.motorization || DEFAULT_HTTP_TIMEOUT),
        catchError(err => {
          this.store.dispatch(appErrorMajor({ error: toAppError(err) }));
          return EMPTY;
        })
      );
    }

    return next.handle(request);
  }
}
